import React, { type ReactNode } from 'react';

import {
	ITEM_LABEL,
	ItemsListBuilder,
	type ItemsListBuilderProps,
} from '@atlassian/company-hub-common';
import { useInitialUnsplashResults } from '@atlassian/company-hub-common/media-components';

import { carouselConfigAnalyticSource } from '../../../../constants';
import type { Frame } from '../../../../types';

import { FrameContent, type FrameContentProps } from './frame-content';

type FramesAreaProps = Omit<
	FrameContentProps,
	'analyticsSource' | 'frameParameters' | 'initialUnsplashResults' | 'isDisabled'
> &
	Omit<ItemsListBuilderProps, 'actionSubjectIdPostFix' | 'analyticsSource' | 'renderItemContent'>;

const actionSubjectIdPostFix = 'Frame';

export const FramesArea = ({ ...framesAreaContainerProps }: FramesAreaProps): React.JSX.Element => {
	const {
		items,
		contentId,
		showBgAndTextColorOptions,
		showMediaPicker,
		showLayout,
		updateFrameFormField,
	} = framesAreaContainerProps;

	const initialUnsplashResults = useInitialUnsplashResults(items);

	const renderFrameContent = (frameParameters: Frame, isFrameDisabled: boolean): ReactNode => (
		<FrameContent
			contentId={contentId}
			frameParameters={frameParameters}
			initialUnsplashResults={initialUnsplashResults}
			isDisabled={isFrameDisabled}
			showBgAndTextColorOptions={showBgAndTextColorOptions}
			showMediaPicker={showMediaPicker}
			showLayout={showLayout}
			updateFrameFormField={updateFrameFormField}
		/>
	);

	return (
		<ItemsListBuilder
			analyticsSource={carouselConfigAnalyticSource}
			actionSubjectIdPostFix={actionSubjectIdPostFix}
			renderItemContent={renderFrameContent}
			itemLabel={ITEM_LABEL.FRAME}
			{...framesAreaContainerProps}
		/>
	);
};
